export function initWixRecorder(experiments: Record<string, string>) {
  window.addEventListener('wixRecorderReady', async () => {
    try {
      await window.wixRecorder!.addLabel('marketing-template-viewer');
      // TODO: add experiments from
      await window.wixRecorder!.withExperiments(experiments);
    } catch (error) {
      console.error(error);
    }
  });
}
